<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.YamlJson.title') }}</span>
      <span class="fmt-spacer" />
      <el-button size="small" icon="el-icon-back" @click="yamlToJson">{{ $t('tool.YamlJson.yamlToJson') }}</el-button>
      <el-button size="small" icon="el-icon-right" @click="jsonToYaml">{{ $t('tool.YamlJson.jsonToYaml') }}</el-button>
      <el-button size="small" plain icon="el-icon-document-copy" @click="doCopy">{{ $t("common.action.copy") }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t("common.action.clear") }}</el-button>
    </div>
    <el-input v-model="code" type="textarea" :rows="18" :placeholder="$t('tool.YamlJson.phInput')"
      class="fmt-textarea" />
    <div class="fmt-status-bar">
      <span v-if="errorMsg" class="fmt-err"><i class="el-icon-warning" /> {{ errorMsg }}</span>
      <span v-else-if="code.trim()" class="fmt-ok"><i class="el-icon-circle-check" /> {{ charCount }}</span>
      <span v-else class="fmt-hint">{{ $t('tool.YamlJson.hint') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:'YamlJsonTool', props:{ config:{ type:Object, default:()=>({}) } },
  data:()=>({ code:'', errorMsg:'' }),
  computed:{ charCount(){ return this.$t('common.hint.charCount', { n: this.code.length }) } },
  methods:{
    parseYaml(s){
      const lines=s.split('\n'),result={},stack=[result],indents=[-1]
      lines.forEach(line=>{
        const trimmed=line.trimEnd();if(!trimmed||trimmed.startsWith('#'))return
        const indent=line.search(/\S/)
        while(indent<=indents[indents.length-1]){stack.pop();indents.pop()}
        const kv=trimmed.match(/^([^:]+):\s*(.*)$/)
        if(kv){
          const key=kv[1].trim(),val=kv[2].trim()
          if(val===''||val==='|'||val==='>'){const obj={};stack[stack.length-1][key]=obj;stack.push(obj);indents.push(indent)}
          else if(val.startsWith('- ')){const arr=[];stack[stack.length-1][key]=arr;stack.push(arr);indents.push(indent)}
          else{let v=val;if(val==='true')v=true;else if(val==='false')v=false;else if(val===''||val==='null')v=null;else if(/^-?\d+$/.test(val))v=parseInt(val);else if(/^-?\d+\.\d+$/.test(val))v=parseFloat(val);stack[stack.length-1][key]=v}
        }
      })
      return result
    },
    toYaml(obj,indent){
      indent=indent||0;const sp='  '.repeat(indent)
      if(obj===null||obj===undefined)return'null'
      if(typeof obj!=='object'){const s=String(obj);return s.includes(':')?'"'+s+'"':s}
      if(Array.isArray(obj))return obj.map(v=>sp+'- '+this.toYaml(v,indent+1)).join('\n')
      return Object.entries(obj).map(function(e){var k=e[0],v=e[1];if(v&&typeof v==='object')return sp+k+':\n'+this.toYaml(v,indent+1);return sp+k+': '+this.toYaml(v)}.bind(this)).join('\n')
    },
    yamlToJson(){this.errorMsg='';if(!this.code.trim())return;try{this.code=JSON.stringify(this.parseYaml(this.code),null,2)}catch(e){this.errorMsg=this.$t('tool.YamlJson.errYaml')+': '+e.message}},
    jsonToYaml(){this.errorMsg='';if(!this.code.trim())return;try{this.code=this.toYaml(JSON.parse(this.code))}catch(e){this.errorMsg=this.$t('tool.YamlJson.errJson')+': '+e.message}},
    doCopy(){if(!this.code.trim()){this.$message.warning(this.$t("common.status.noContent"));return};navigator.clipboard.writeText(this.code);this.$message.success(this.$t("common.status.copied"))},
    clearAll(){this.code='';this.errorMsg=''},
    doAction(a){if(a==='clear')this.clearAll()}
  }
}
</script>

<style scoped>
.fmt-tool { display: flex; flex-direction: column; gap: 12px; }
.fmt-toolbar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.fmt-toolbar >>> .el-button + .el-button { margin-left: 0; }
.fmt-label { font-size: 13px; font-weight: 700; color: #1a1f36; }
.fmt-spacer { flex: 1; }
.fmt-textarea >>> textarea { font-family:'JetBrains Mono','Fira Code','Consolas',monospace !important;font-size:13px !important;line-height:1.6 !important;border-radius:10px;resize:vertical;min-height:360px; }
.fmt-status-bar { font-size: 12px; }
.fmt-err { color: #f56c6c; display: flex; align-items: center; gap: 4px; }
.fmt-ok { color: #67c23a; display: flex; align-items: center; gap: 4px; }
.fmt-hint { color: #c0c4cc; }
</style>
